import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import * as Bixby from '$/core';
import { ColumnApi, GridApi, ICellRendererParams } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import PasteOnlyFloatingFilter from '$/components/global/floatingFilters/PasteOnlyFloatingFilter';
import './ClientTasksPostings.scss';

interface IClientTasksPostingsProps {
  client?: Bixby.Models.Client;
}

const ClientTasksPostings: React.FC<IClientTasksPostingsProps> = props => {
  const { client } = props;
  const [, setGridApi] = useState(null as GridApi | null);
  const [, setGridColumnApi] = useState(null as ColumnApi | null);

  const clientCompanies = useMemo(
    () => (client && client.companies ? client.companies.filter(_ => !_.isSECPublic) : undefined),
    [client]
  );

  const getContextMenuItems = () => {
    const result = ['copy', 'copyWithHeaders', 'separator', 'expandAll', 'contractAll', 'separator', 'export'];
    return result;
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  return client && clientCompanies ? (
    <section className="client_taskspostings">
      <div className="spreadsheet">
        {clientCompanies && !Bixby.Utils.isNullOrEmpty(clientCompanies) ? (
          <div className="client-taskspostings-data-grid">
            <div className="grid_container">
              <div className="grid ag-theme-alpine">
                <AgGridReact
                  enableRangeSelection={false}
                  getContextMenuItems={getContextMenuItems}
                  defaultColDef={{
                    flex: 1,
                    minWidth: 100,
                    sortable: true,
                    resizable: true,
                    lockPinned: true,
                  }}
                  onGridReady={onGridReady}
                  rowData={clientCompanies}
                  suppressDragLeaveHidesColumns={true}
                  suppressMovableColumns={true}
                  suppressCellFocus={true}
                  animateRows={true}
                  rowHeight={32}
                  headerHeight={32}
                  components={{ pasteOnlyFloatingFilter: PasteOnlyFloatingFilter }}
                  columnDefs={[
                    {
                      headerName: 'Data Site Name',
                      field: 'dataSiteName',
                      floatingFilterComponentParams: { suppressFilterButton: true },
                      filter: 'agTextColumnFilter',
                      floatingFilter: true,
                      floatingFilterComponent: 'pasteOnlyFloatingFilter',
                      cellRenderer: (params: ICellRendererParams) => {
                        if (params.value) {
                          return (
                            <a className="bix-link link_underline" href={`/admin/company/${params.data['company_Id']}`}>
                              {params.value}
                            </a>
                          );
                        } else {
                          return '';
                        }
                      },
                    },
                    { headerName: 'Company Name', field: 'company_Name' },
                    { headerName: 'Bixby ID', field: 'bixbyId' },
                  ]}></AgGridReact>
              </div>
            </div>
          </div>
        ) : (
          <p className="space_around">{`There are no companies associated with ${client.name}.`}</p>
        )}
      </div>
    </section>
  ) : null;
};

const mapDispatchToProps = () => ({});
const mapStateToProps = (state: AppState) => {
  return {
    client: state.clientState.currentClient,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientTasksPostings);
